import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=ef1ccf8a&scoped=true&"
import script from "./poster.vue?vue&type=script&lang=js&"
export * from "./poster.vue?vue&type=script&lang=js&"
import style0 from "./poster.vue?vue&type=style&index=0&id=ef1ccf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1ccf8a",
  null
  
)

export default component.exports